import auth from './auth'
import { allRequest } from './dashboardReducer'
import newRequest from './newRequest'
import requestDetails from './requestDetails'
import portal from './portal'
import termsPrivacy from './termsPrivacy'
import reports from './reports'
import requestDocs from './requestDocs'
import management from './management';
import user from './user';
import dateFormat from './dateFormat';
import homeCustomer from './homeCustomer';
import assetType from './assetType';
import storyboard from './storyboard';
import currency from './currency';
import notificationUser from './notificationUser';
import recentAccess from './recentAccess';
import { cpadminSlice } from './cpadminService';
import { authServiceSlice } from './authServiceSlice';
import documents from './documents';
import client from './client';
import requestAccess from './requestAccess';
import inquiry from './inquiry';

const REDUCERS = {
    auth,
    allRequest,
    newRequest,
    requestDetails,
    portal,
    termsPrivacy,
    reports,
    requestDocs,
    management,
    user,
    dateFormat,
    homeCustomer,
    assetType,
    storyboard,
    currency,
    notificationUser,
    recentAccess,
    [cpadminSlice.reducerPath]: cpadminSlice.reducer,
    [authServiceSlice.reducerPath]: authServiceSlice.reducer,
    documents,
    client,
    requestAccess,
    inquiry
};
export default REDUCERS;